module.exports = __webpack_public_path__ + "static/media/cash.c5e21215.svg";